/**
 * How the on-call rota wears a cover type's colour (set on Rota Admin ->
 * Cover types).
 *
 * The stored colour paints a rota cell's left edge and, behind an ASSIGNED
 * cell, a pale wash of the same colour. An unassigned cell keeps the red
 * "missing" wash from the stylesheet - that is a warning, not an identity -
 * but still carries the type's colour on its edge, so which cover is missing
 * reads at a glance. Anything that is not a six-digit hex colour falls back to
 * the stylesheet's own colours, so a bad value can never blank a cell.
 */

const HEX_COLOUR = /^#[0-9a-fA-F]{6}$/;

export const isCoverColour = (value) => typeof value === 'string' && HEX_COLOUR.test(value);

// rgba() rather than eight-digit hex: every browser and the test DOM read it.
function wash(colour, opacity) {
  const [r, g, b] = [1, 3, 5].map((at) => parseInt(colour.slice(at, at + 2), 16));
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function coverTypeStyle(colour, { assigned = true } = {}) {
  if (!isCoverColour(colour)) return {};
  return assigned
    ? { borderLeftColor: colour, background: wash(colour, 0.12) }
    : { borderLeftColor: colour };
}
